module.exports = __webpack_public_path__ + "media/images/responsive/lp/clean/icon_number_02-6e9ea5c0d65eac886eb8ff344d576645.svg";